import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { customerApi } from '../services/api'
import Loading from '../components/Loading'
import ErrorMessage from '../components/ErrorMessage'
import EmptyState from '../components/EmptyState'
import StatusBadge from '../components/StatusBadge'
import { channelMap, formatDateTime } from '../utils/helpers'
import type { Order } from '../types'

export default function CustomerOrders() {
  const navigate = useNavigate()
  const [orders, setOrders] = useState<Order[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const fetchOrders = async () => {
    setLoading(true)
    setError('')
    try {
      const data = await customerApi.getOrders()
      setOrders(data as Order[])
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : '加载失败'
      setError(message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchOrders()
  }, [])

  if (loading) return <Loading />
  if (error) return <ErrorMessage message={error} onRetry={fetchOrders} />

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#eeeeee' }}>
      {/* Nav */}
      <div className="nav-bar">
        <button
          onClick={() => navigate('/')}
          style={{ color: '#9a9a9a', background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5}>
            <path d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h1
          style={{
            fontFamily: '"Noto Sans SC", sans-serif',
            fontSize: 16,
            fontWeight: 500,
            color: '#313131',
            letterSpacing: '0.15em',
          }}
        >
          我的订单
        </h1>
        <div style={{ width: 20 }} />
      </div>

      <div style={{ padding: '24px' }}>
        {/* Order count */}
        <p
          style={{
            fontSize: 13,
            color: '#9a9a9a',
            letterSpacing: '0.15em',
            marginBottom: 16,
          }}
        >
          共 {orders.length} 个订单
        </p>

        {orders.length === 0 ? (
          <EmptyState
            title="暂无订单"
            description="通过订单号查询后，订单将自动关联到您的账户"
          />
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {orders.map((order) => (
              <div
                key={order.id}
                className="card"
                onClick={() => navigate(`/detail/${order.orderNo}`)}
                style={{ cursor: 'pointer' }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: 8,
                  }}
                >
                  <span
                    style={{
                      fontSize: 13,
                      color: '#9a9a9a',
                      letterSpacing: '0.15em',
                    }}
                  >
                    {channelMap[order.channel]}
                  </span>
                  <StatusBadge status={order.status} />
                </div>
                <div
                  style={{
                    fontFamily: '"Noto Sans SC", sans-serif',
                    fontSize: 16,
                    fontWeight: 500,
                    color: '#313131',
                    letterSpacing: '0.15em',
                    marginBottom: 4,
                  }}
                >
                  {order.orderNo}
                </div>
                <div
                  style={{
                    fontSize: 13,
                    color: '#9a9a9a',
                    letterSpacing: '0.15em',
                  }}
                >
                  {formatDateTime(order.createdAt)}
                </div>
                {order.specs && order.specs.length > 0 && (
                  <div
                    style={{
                      marginTop: 8,
                      fontSize: 13,
                      color: '#9a9a9a',
                      letterSpacing: '0.15em',
                    }}
                  >
                    {Array.isArray(order.specs) ? order.specs.map((s) => `${s.type}×${s.quantity}`).join(' · ') : ''}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Bind new order */}
        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <button
            onClick={() => navigate('/customer/query')}
            className="btn-ghost"
            style={{ fontSize: 15 }}
          >
            查询并关联新订单
          </button>
        </div>
      </div>
    </div>
  )
}
